import React from "react";
import { useParams } from "react-router-dom";
import { ProfilingProtocolDetailContent } from "./ProfilingProtocolDetailContent";
import styles from "./ProfilingProtocolDetailPage.module.scss";

/**
 * Wrapper standalone per deep-link diretti:
 * /dashboard/users/:athleteId/profiling/:protocolId
 * Back → /dashboard/users/:athleteId?tab=testing&testingMode=profiling
 */
export const ProfilingProtocolDetailPage: React.FC = () => {
  const { athleteId, protocolId } = useParams<{
    athleteId: string;
    protocolId: string;
  }>();

  if (!athleteId || !protocolId) return null;

  return (
    <div className={styles.pageWrapper}>
      <div className={styles.scrollArea}>
        <div className={styles.inner}>
          <ProfilingProtocolDetailContent
            athleteId={athleteId}
            protocolId={protocolId}
            /* onBack assente: usa il back Link interno al componente */
          />
        </div>
      </div>
    </div>
  );
};

export default ProfilingProtocolDetailPage;
